<div class="container" fxLayout="column" fxLayoutAlign="space-between stretch" class="h-100">
  <product-specification-tree
    [productSpecifications]="data.productSpecifications"
    [productTypeIdFilter]="data.productTypeIdFilter"
    [selectedProductSpecificationIds]="data.productSpecificationIds"
    [expandAll]="true"
    [readOnly]="false"
    (onProductSpecificationSelectionChanged)="onProductSpecificationSelectionChanged($event)"
    ></product-specification-tree>

    <div class="p-b-20" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
      <button type="button" mat-flat-button color="accent" (click)="onConfirmSelection()" matTooltip="Confirm Product Specification selection">
        <mat-icon >check</mat-icon> Confirm
      </button>

      <button type="button" mat-stroked-button color="basic" (click)="nagivateBack()" matTooltip="Cancel Product Specification selection">
        <mat-icon>clear</mat-icon> Cancel
      </button>
    </div>
</div>